import {
  ListCard,
  MainButton,
  HeaderContainer,
  PrimaryHeading,
  BodyContainer,
  RightMainContainer,
  ListIconWrapper,
  LoadingListCards,
  TemplateNotFound,
  Loader,
  InputField,
} from "commonUI";
import { Link } from "react-router-dom";
import { AddIcon, PhaseIcon } from "allIcons";
import {
  usePhases,
  useDeletePhase,
  useAddNewPhase,
} from "api/templateLibrary/phases";
import { Children, useDeferredValue, useEffect, useState } from "react";
import { useUserPermissions } from "hooks/user";
import { libraryItemSorting } from "filterAndSort/templateLibrary";
import { isEqual, search } from "helpers";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function Phases() {
  const { data: phases, isLoading: loadingPhases } = usePhases();
  const { mutate: deletePhase, isLoading: isDeleting } = useDeletePhase();
  const { mutate: duplicatePhase, isLoading: isDuplicating } = useAddNewPhase();
  const { add_new_templates, edit_templates, delete_templates } =
    useUserPermissions();

  const [searchText, setSearchText] = useState("");
  const defferedSearch = useDeferredValue(searchText);
  const [searchResult, setSearchResult] = useState([]);

  useEffect(() => {
    setSearchResult(
      phases.filter((task) => search(task.title, defferedSearch))
    );
  }, [defferedSearch, phases]);

  const applySorting = (order, orderBy) => {
    setSearchResult((prevSearchResult) =>
      libraryItemSorting(order, orderBy, prevSearchResult)
    );
  };

  return (
    <>
      <RightMainContainer>
        <Loader loader="block" show={isDeleting || isDuplicating} />
        <HeaderContainer>
          <PrimaryHeading>{t("libraryTemplate.phases.title")}</PrimaryHeading>
          {add_new_templates ? (
            <Link to="add">
              <MainButton>
                <AddIcon />
                {t("button.add")}
              </MainButton>
            </Link>
          ) : (
            ""
          )}
        </HeaderContainer>
        <BodyContainer>
          <InputField
            placeholder={t("input.search.placeholder")}
            searchIcon
            value={searchText}
            setValue={setSearchText}
            applySorting={applySorting}
            filter={false}
            sort
          />
          <div className="">
            {loadingPhases ? (
              <LoadingListCards />
            ) : searchResult.length === 0 ? (
              <TemplateNotFound
                label={t("libraryTemplate.phases.title")}
                linkLabel={t("libraryTemplate.phase")}
                link={add_new_templates ? "add" : ""}
              />
            ) : (
              Children.toArray(
                searchResult.map((ele, index) => {
                  return (
                    <ListCard
                      data={ele.title}
                      secondaryData={
                        ele.target_date_days &&
                        !isEqual(ele.target_date_days, 0)
                          ? t("libraryTemplate.phases.durationDays", {
                              duration: ele.target_date_days,
                            })
                          : ""
                      }
                      key={index}
                      index={index}
                      link={
                        edit_templates
                          ? `/${ModulePrefixes.TEMPLATE_LIBRARY}/phases/${ele.id}`
                          : ""
                      }
                      strictLink={true}
                      duplicate={add_new_templates}
                      editIcon={edit_templates}
                      onDuplicate={() =>
                        duplicatePhase({
                          ...ele,
                          title: `Copy of ${ele.title}`,
                        })
                      }
                      deleteIcon={!delete_templates}
                      onDelete={() => deletePhase(ele.id)}
                      icon={
                        <ListIconWrapper>
                          <PhaseIcon />
                        </ListIconWrapper>
                      }
                      deleteTitle={t("libraryTemplate.delete.title")}
                      deleteButtonText={t("libraryTemplate.delete.button")}
                      deleteMessage={t("libraryTemplate.delete.message")}
                    />
                  );
                })
              )
            )}
          </div>
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
